import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a USD money amount for the AI-usage surfaces, where token costs are
 * billed in US dollars (Anthropic pricing). Mirrors the [[ZarPipe]] conventions:
 *
 *   "USD" prefix + space + thousands separator. A null / unknown amount renders
 *   as "—" (em dash), never "N/A" or blank.
 *
 * Amounts arrive from the API as decimal strings. Token costs are typically
 * fractions of a cent, so up to 4 decimal places are shown to avoid rounding a
 * real cost down to "USD 0.00"; whole dollars drop the cents.
 *
 *   {{ e.cost_usd | usd }}       → "USD 0.0123"
 *   {{ '12.5' | usd }}           → "USD 12.50"
 *   {{ null | usd }}             → "—"
 */
@Pipe({ name: 'usd', standalone: true, pure: true })
export class UsdPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }
    const num = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(num)) {
      return '—';
    }
    const hasCents = !Number.isInteger(num);
    const formatted = num.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 4,
    });
    return `USD ${formatted}`;
  }
}
